// ETHRAEON About page · Phase S
// (c) S. Jason Prohaska (ingombrante) 2024-2026

export function About() {
  return (
    <main className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-neutral-50">
      <section className="max-w-3xl mx-auto px-6 py-24">
        <h1 className="text-4xl md:text-5xl font-light">About</h1>
        <p className="mt-8 text-lg text-neutral-700 dark:text-neutral-300">
          Ethraeon is a human-first orchestration system for calm decision support. It helps people
          understand options, boundaries, and reasoning without introducing pressure or replacing
          judgment.
        </p>
      </section>
    </main>
  );
}
